import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from 'src/app/service/auth.service';
import { GeneralService } from 'src/app/service/general.service';
import { WebhookService } from 'src/app/service/webhook.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit, OnChanges {
  @Input() openSideBar: boolean = false;
  @Input() currentUser: any = {};
  @Input() fetchingData: boolean = false;
  @Input() title: string = '';
  @Input() showBackButton: boolean = false;
  @Input() backUrl: string = '';
  @Input() menuRef: any = '';
  @Input() urlQuery: any = {};
  @Output() openCompliance: EventEmitter<boolean> = new EventEmitter();
  @Output() toggleSidebarTest: EventEmitter<boolean> = new EventEmitter();
  @Output() openSideBarChange: EventEmitter<boolean> = new EventEmitter();
  @Input() toggleMenu:any = ()=>{}
  currentUrl: string = '';
  userData: any = {};
  webhooks: any = {};
  total: number = 0;
  isDropdownOpen: boolean = false;
 

  constructor(
    private router: Router,
    private generalService: GeneralService,
    private authService: AuthService,

  ) {
    this.router.events.subscribe((route) => {
      // console.log(router.url)
      this.getPageTitle();
    });
  }
  ngOnInit() {
    this.getUserdata();
  }

  openDropdown = () => {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleSidebar_() {
    // this.openSideBar = !this.openSideBar;
    // this.openSideBarChange.emit(this.openSideBar);
    // console.log("click")
    this.toggleSidebarTest.emit();
    this.toggleMenu()
  }

  ngOnChanges(){
    // console.log(this.toggleMenu)
  }
  getPageTitle = () => {
    if (this.router.url === '/home' || this.router.url === '/home/')
      this.title = 'Dashboard';
    else {
      if (this.router.url.includes('webhook')) this.title = 'WebHooks';
      else if (
        this.router.url === '/requests' ||
        this.router.url === '/requests/'
      )
        this.title = 'Requests';
      else this.title = 'Settings';
    }
    // console.log(this.title)
  };

  async getUserdata() {
    // this.fetchingData = true;
    (await this.authService.getUserData()).subscribe({
      next: (res: any) => {
        this.userData = res.data;
        // console.log(this.userData);
        error: (error: any) => {
          // this.fetchingData = false;
        };
      },
    });
  }



  logout() {
    this.generalService.logoutUser();
    this.isDropdownOpen = false;
  }
  updatePassword() {}
}
